/**
 * Wording shared by the owner's promo code pages and the buyer's product page.
 * @see mintly-back/src/services/promoCodeService
 */

export const money = (amount, currency = "GEL") => {
  const n = Number(amount || 0);
  const text = Number.isInteger(n) ? String(n) : n.toFixed(2);
  return currency === "GEL" ? `₾${text}` : `${currency} ${text}`;
};

/** "20% off", "₾5 off". */
export const discountLabel = (promo, t) =>
  promo.discountType === "fixed"
    ? t("promoCodes.discountFixed", { amount: money(promo.discountValue, promo.currency) })
    : t("promoCodes.discountPercent", { value: Number(promo.discountValue) });

/**
 * Why a code was refused, in the reader's language. The server's English message is
 * the fallback for a reason this page has no words for.
 */
export const promoErrorText = (t, scope, code, fallback) => {
  const key = `promoCodes.${scope}.errors.${code}`;
  const text = code ? t(key) : key;
  return text !== key ? text : fallback;
};
